module.exports = __webpack_public_path__ + "img/电子签章代理授权.6cc1c0ac.png";